import { Pipe, PipeTransform } from '@angular/core';
import { Land } from '../../models/land/Land';

@Pipe({
  name: 'land',
  standalone: true
})
export class LandPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return '';
    }
    const landName = Land[value as keyof typeof Land];
    return landName ? landName : value;
  }

}

